import { motion } from "framer-motion";

/**
 * Animated, theme-aware AI auto-tagging mockup: a saved bookmark with AI
 * suggesting collections/tags that pop in one by one. Replaces ai-collections
 * screenshots.
 */

const TAGS = ["Development", "React", "Frontend", "Tutorial"];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.13, delayChildren: 0.5 } },
};
const pop = {
  hidden: { opacity: 0, scale: 0.6 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: "easeOut" } },
};

export const AITaggingMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--ai ${className}`}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-stars me-1" />
          AI categorization
        </div>
      </div>

      <div className="obm-mock__body">
        <div className="obm-mock__item mb-3">
          <span className="obm-mock__fav" style={{ background: "#3b82f6" }}>
            R
          </span>
          <div className="obm-mock__meta">
            <span className="obm-mock__title">Building accessible React apps</span>
            <span className="obm-mock__domain">react.dev/learn/accessibility</span>
          </div>
        </div>

        <div className="obm-mock__ai-head">
          <span className="obm-mock__ai-spark">
            <i className="bi bi-magic" />
          </span>
          Suggested collections
        </div>

        <motion.div
          className="obm-mock__chips"
          variants={container}
          initial={false}
          animate="show"
        >
          {TAGS.map((tag, i) => (
            <motion.span
              key={tag}
              className={`obm-mock__chip ${i < 2 ? "is-active" : ""}`}
              variants={pop}
            >
              {i < 2 && <i className="bi bi-plus-lg me-1" />}
              {tag}
            </motion.span>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AITaggingMock;
